<template>
	<div>
		<el-dialog :visible.sync="showDialog" :modal="false" :show-close="false" destroy-on-close append-to-body width="45vw" custom-class="register-dialog">
			<div class="register-wrap flex-row">
				<div class="right">
					<div class="close-dialog" @click="closeDialog">
						<img src="../../assets/images/close_icon.png" />
					</div>
					<h1 class="ft-20 t-center">欢迎注册</h1>
					<div class="form-wrap">
						<el-form ref="registerForm" :model="form" :rules="rules" hide-required-asterisk label-width="6.5vw">
							<el-form-item label="手机号码" prop="phone">
								<el-input v-model="form.phone" placeholder="请输入手机号码" clearable autocomplete="off">
								</el-input>
							</el-form-item>
							<el-form-item label="验证码" class="code-item" prop="smscode">
								<el-input v-model="form.smscode" placeholder="请输入短信验证码">
									<el-button slot="append" v-if="timerTime > 0">{{timerTime}} 秒后重新获取</el-button>
									<el-button slot="append" v-else @click="showVerify">获取验证码</el-button>
								</el-input>
							</el-form-item>
							<el-form-item label="密码" prop="password">
								<el-input v-model="form.password" placeholder="请设置6-12位登录密码、数字字母组成" clearable show-password autocomplete="off">
								</el-input>
							</el-form-item>
							<el-form-item label="姓名" prop="realname">
								<el-input v-model="form.realname" placeholder="请输入真实姓名" clearable autocomplete="off">
								</el-input>
							</el-form-item>
							<el-form-item label="身份证号码" class="identity-input" prop="idCard">
								<el-input v-model="form.idCard" placeholder="请输入身份证号" clearable autocomplete="off">
								</el-input>
							</el-form-item>
							<el-form-item class="checked-item">
								<el-checkbox v-model="checked">勾选同意</el-checkbox>
								<p @click="showTreaty">《用户服务协议》</p>
							</el-form-item>
							<el-form-item class="login-button">
								<el-button :disabled="!checked" type="primary" @click="onSubmit">确认</el-button>
							</el-form-item>
							<el-form-item>
								<div class="tips_wrap flex-row ft-14">
									<p @click="showLogin"><a>已有账号,立即登录</a></p>
								</div>
							</el-form-item>
						</el-form>
					</div>
					<Verify
						@success="verifySuccess"
						:mode="'pop'"
						captchaType="clickWord"
						:imgSize="{ width: '330px', height: '155px' }"
						ref="verify"
					></Verify>
				</div>
			</div>
			<treaty-dialog ref="treatyDialog"></treaty-dialog>
		</el-dialog>
	</div>
</template>

<script>
	import Verify from '../verifition/Verify.vue'
	import TreatyDialog from './treatyDialog.vue'
	import { getSmsCaptcha,register } from '@/api/login.js'
	export default{
		name: 'register',
		components: {Verify,TreatyDialog},
		data() {
			var captchaTypeValue = 'clickWord'
			var min = 0
			var max = 100
			var random = Math.floor(Math.random() * (max - min)) + min
			
			if (random % 2 === 0) {
				captchaTypeValue = 'blockPuzzle'
			}
			if (random % 2 === 1) {
				captchaTypeValue = 'clickWord'
			}
			// 身份证验证规则
			const idCard = (rule, value, callback) => {
				if (!value) {
					callback(new Error('请输入身份证号'))
				} else {
					const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
					if (reg.test(value)) {
						callback()
					} else {
						return callback(new Error('请输入正确的身份证号'))
					}
				}
			}
			// 中名验证
			const chnName = (rule, value, callback) => {
				if (!value) {
					callback(new Error('请输入真实姓名'))
				} else {
					const reg = /^[\u4e00-\u9fa5]+$/
					if (value.length < 100 && reg.test(value)) {
						callback()
					} else {
						return callback(new Error('请输入正确的中文名'))
					}
				}
			}
			return {
				showDialog: false,
				checked: true,
				timerTime: 0, // 手机验证码发送时间
				captchaType: captchaTypeValue,
				form: {
					phone: '',
					smscode: '',
					password: '',
					realname: '',
					idCard: ''
				},
				rules: {
					realname: [
						{ required: true, validator: chnName, trigger: 'blur' },
						{ min: 2, max: 5, message: '长度在 2 到 5 个字符', trigger: 'blur' }
					],
					smscode: [
						{ required: true, message: '请输入短信验证码',trigger: 'blur'},
					],
					phone: [
						{ required: true, message: '请输入手机号码',trigger: 'blur'},
						{ pattern: /^1[3456789]\d{9}$/, message: '包含了非法字符,请重新输入' }
					],
					password: [
						{ required: true, message: '请设置6-12位登录密码',trigger: 'blur' },
						{ pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,12}$/, message: '密码须包含数字、字母两种元素，且密码位数为6-12位' }
					],
					idCard: [
						{ required: true, validator: idCard, trigger: 'blur' }
					]
				}
			}
		},
		methods: {
			show(){
				this.showDialog = true
			},
			showLogin() {
				this.showDialog = false
				this.$emit('showLogin')
			},
			closeDialog() {
				this.showDialog = false
			},
			showTreaty() {
				this.$refs.treatyDialog.show()
			},
			showVerify() {
				let that = this
				this.$refs.registerForm.validateField('phone', (mobile_check) => {
					if(mobile_check) return
					that.$refs.verify.show()
				})
			},
			/**
			 * 获取验证码
			 */
			verifySuccess(params) {
				let data = {
					mobile: this.form.phone,
					smsmode: '1',
					code: params.captchaVerification
				}
				getSmsCaptcha(data).then(res => {
					if (res.success) {
						this.$message.success('短信验证码发送成功')
						this.timerTime = 60
						this.timer = setInterval(() => {
							if (this.timerTime > 0) {
								this.timerTime--
							} else {
								this.timer = null
								clearInterval(this.timer)
							}
						}, 1000)
					} else {
						this.$message.warning(res.message)
					}
				})
			},
			onSubmit() {
				this.$refs.registerForm.validate((valid) => {
					if (valid) {
						register(this.form).then(res =>{
							if (res.success) {
								// this.$store.state.user.token = res.result.token
								// this.$store.state.user.info = res.result.userInfo
								// this.$store.state.user.isLogin = true
								// localStorage.setItem('token',res.result.token)
								// localStorage.setItem('userInfo',JSON.stringify(res.result.userInfo))
								this.showDialog = false
								this.$emit('successRegister',{title: res.message})
							}
						})
					} else {
						return false;
					}
				});
			}
		}
	}
</script>

<style lang="scss" scoped>
	/deep/ .register-dialog{
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%,-50%);
		margin: 0!important;
		// height: 80vh;
		background: linear-gradient(141deg, #2A2A33 0%, #1A1A1F 100%);
		box-shadow: 0px 7px 17px 0px rgba(0, 0, 0, 0.53);
		border-radius: 20px;
		border: 1px solid #3D414F;
		overflow: hidden;
		.el-dialog__header{
			display: none;
		}
		.el-dialog__body{
			height: 100%;
			padding: 0;
			.el-input__inner{
				background: #0C0C10;
				border-radius: 4px;
				opacity: 0.9678;
				border: none;
				outline: none;
			}
			.register-wrap{
				height: 100%;
				justify-content: space-between;
				.right{
					position: relative;
					height: 100%;
					width: 100%;
					padding-top: 4vh;
					h1{
						color: #FFF;
						margin-bottom: 4vh;
					}
					.close-dialog{
						position: absolute;
						right: 1vw;
						top: 1vw;
						cursor: pointer;
						transition: all .3s ease;
						&:hover{
							opacity: .5;
						}
						img{
							display: block;
						}
					}
					.form-wrap{
						width: 60%;
						margin-left: 18%;
						.el-form{
							.el-form-item{
								.el-form-item__label,.el-checkbox__label{
									color: #FFF;
								}
								&.code-item{
									.el-form-item__content{
										.el-input{
											.el-input__inner{
												border-radius: 4px 0 0 4px;
											}
											.el-input-group__append{
												color: #3C78DD;
												border: none;
												outline: none;
												background-color: #0C0C10;
												.el-button{
													height: 40px;
													padding: 0 1vw;
												}
											}
										}
									}
								}
								&.identity-input{
									margin-bottom: 0;
								}
								&.checked-item{
									.el-form-item__content{
										line-height: initial;
										display: flex;
										justify-content: flex-start;
										align-items: center;
										p{
											margin-top: 2.5vh;
											line-height: 19px;
											font-size: 14px;
											color: #3C78DD;
											cursor: pointer;
										}
									}
								}
								&.login-button{
									margin-top: 4vh;
									margin-bottom: 0;
									.el-button{
										width: 100%;
									}
								}
								.tips_wrap{
									p{
										a{
											cursor: pointer;
											color: #3C78DD;
										}
									}
								}
							}
							.el-checkbox{
								margin-top: 2.5vh;
							}
						}
					}
				}
			}
		}
	}
</style>
